// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1dOkh","fileBtn":"File_fileBtn__HYrWF","closeBtn":"File_closeBtn__2zg4d","fileSelected":"File_fileSelected__2dkY_","disabled":"File_disabled__3Z8aG"};